<template>
  <b-card
    title="دوره های ورزشی"
    border-variant="dark"
  >
    <b-card-body>
      <b-button
        variant="primary"
        class="mb-1"
      >
        جدید
      </b-button>
      <b-table
        bordered
        hover
        striped
        responsive
        :items="items"
        :fields="fields"
        class="mt-1 mb-2 position-relative"
        :busy="loading"
        :no-local-sorting="true"
      >
        <template #cell(show_details)="row">
          <feather-icon
            :icon="row.detailsShowing? 'EyeOffIcon':'EyeIcon'"
            size="16"
            class="ml-1"
            @click="row.toggleDetails"
          />
          <feather-icon
            icon="EditIcon"
            size="16"
            class="ml-1"
            @click="editExpireDate(row)"
          />
          <feather-icon
            :icon="row.item.isActive? 'XCircleIcon':'CheckCircleIcon'"
            size="16"
            class="ml-1 cursor-pointer"
            @click="suspendTerm(row.item.Id)"
          />
        </template>
        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>Full Name : </strong>{{ row.item.Id }}
              </b-col>
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>Post : </strong>{{ row.item.CreatedAt }}
              </b-col>
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>Email : </strong>{{ row.item.dietMethod }}
              </b-col>
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>City : </strong>{{ row.item.diet }}
              </b-col>
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>Salary : </strong>{{ row.item.duration }}
              </b-col>
              <b-col
                md="4"
                class="mb-1"
              >
                <strong>Age : </strong>{{ row.item.bank }}
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              بستن
            </b-button>
          </b-card>
        </template>
      </b-table>
    </b-card-body>
    <b-modal
      v-model="showEditExpireDateModal"
      ok-only
      ok-title="Accept"
      modal-class="modal-primary"
      centered
      title="تغییر تاریخ انقضا"
    >
      <b-card-text>
        <date-picker v-model="ExpireDate" />
      </b-card-text>
    </b-modal>
    <b-modal
      v-model="addNewTerm"
      ok-only
      ok-title="Accept"
      modal-class="modal-primary"
      centered
      title="تغییر تاریخ انقضا"
    >
      <b-card-text>
        <h1>add new term</h1>
      </b-card-text>
    </b-modal>
  </b-card>
</template>
<script>
export default {
  name: 'UserSportTerms',
  data() {
    return {
      loading: false,
      ExpireDate: '2020/85/9',
      fields: [
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'dietMethod',
          label: 'متود',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'diet',
          label: 'رژیم',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'duration',
          label: 'مدت دوره',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'bank',
          label: 'بانک',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'transactionNumber',
          label: 'شماره تراکنس',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'expireData',
          label: 'تاریخ انقضا',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'show_details',
          label: '',
          thClass: 'width-20-per',
        },
      ],
      items: [
        {
          Id: 1,
          CreatedAt: '2020/2/2',
          dietMethod: 'کاهش وزن',
          diet: 'عمومی',
          duration: '4 ماه',
          bank: 'زرین پال ',
          transactionNumber: '123456',
          expireData: '2021/4/2',
          isActive: true,
        },
        {
          Id: 2,
          CreatedAt: '2020/2/2',
          dietMethod: 'کاهش وزن',
          diet: 'عمومی',
          duration: '4 ماه',
          bank: 'زرین پال ',
          transactionNumber: '123456',
          expireData: '2021/3/2',
          isActive: false,
        },
        {
          Id: 3,
          CreatedAt: '2020/2/2',
          dietMethod: 'کاهش وزن',
          diet: 'عمومی',
          duration: '4 ماه',
          bank: 'زرین پال ',
          transactionNumber: '123456',
          expireData: '2021/2/2',
          isActive: true,
        },

      ],
      addNewTerm: false,
      showEditExpireDateModal: false,
    }
  },
  methods: {
    suspendTerm() {
      this.$bvModal.msgBoxConfirm('آیا مطمئن هستید که می خواهید این ترم را غیرفعال کنید؟', {
        title: 'حذف',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'غیرفعال شود',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      })
        .then(confirm => {
          if (confirm) {
            const obj = {}
            obj[name] = value
            this.$http.post(url, obj)
              .then(() => {
                this.update()
              })
          }
        })
    },
    editExpireDate(row) {
      this.showEditExpireDateModal = true
      this.ExpireDate = row.item.expireData
    },
  },
}
</script>

<style scoped>

</style>
